import styled from 'styled-components';
import { Box, Tooltip } from '@mui/material';
import { withStyles } from 'tss-react/mui';

import { colors } from '@/globalStyles';

export const TooltipStyled = withStyles(Tooltip, () => ({
  tooltip: {
    backgroundColor: colors.white,
    color: colors.black,
    boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.25)',
    fontSize: 16,
    fontWeight: 'normal',
    padding: 0,
    borderRadius: 6,
    maxWidth: 'unset'
  },
  arrow: {
    color: colors.white,
    '&:before': {
        boxShadow: '0 0 3px 0 rgba(0, 0, 0, 0.25)',
    },
  },
}));

export const OptionPanelTooltipStyled = withStyles(Tooltip, () => ({
  tooltip: {
    backgroundColor: colors.white,
    color: colors.black,
    boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.25)',
    fontSize: 16,
    fontWeight: 'normal',
    padding: 0,
    borderRadius: 6,
    maxWidth: 'unset'
  },
  arrow: {
    left: 'unset !important',
    right: '23px !important',
    transform: 'unset !important',
    color: colors.white,
    '&:before': {
        boxShadow: '0 0 3px 0 rgba(0, 0, 0, 0.25)',
    },
  },
}));
